import { differenceInDays, startOfDay } from '@if/core/date'

export const convertToLocalDate = (date: string) => {
  return new Date(date.replace(/-/g, '/'))
}

export const formatPhone = (phoneNumber: string | undefined | null): string => {
  if (!phoneNumber) return 'N/A'
  const phoneNumberClean = phoneNumber.replace(/-/g, '')
  return `${phoneNumberClean.slice(0, 3)}-${phoneNumberClean.slice(3, 6)}-${phoneNumberClean.slice(6)}`
}

export const calculateDaysUntilExpiration = (expiresOn: Date): number => {
  const today = startOfDay(new Date())
  const expiration = startOfDay(expiresOn)
  return differenceInDays(expiration, today)
}
